
export class InspectionFormatterGroup {
  public name!: string;

  constructor(name: string) {
    this.name = name;
  }
}
